export default "__VITE_ASSET__db5a38a9__"